import React from "react";
import AppointmentDetailComponent from "@components/User/Appointment/AppointmentDetail/AppointmentDetail";

export default function AppointmentDetail() {
  return <AppointmentDetailComponent />;
}
